// removed by extract-text-webpack-plugin
module.exports = {"container":"_3oxEfjXygEclVlMxi4x1Ok","input":"WQthM_wSFfzM7N7CRQwR0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchBar/SearchBar.scss
// module id = 1311
// module chunks = 1